<script setup lang="ts">
import { useAuthStore } from "~/store/auth/auth.store";

const authStore = useAuthStore();

const { $Localize } = useNuxtApp();

const typedLocalize: any = $Localize;

onMounted(() => {
  // No fetchProfile() here: this layout only ever mounts behind `auth.global.ts`, which guarantees
  // isLoggedIn() — and that getter already requires `user`. The profile was loaded by `login()`
  // (funnel) or by `auth-plugin.ts` (reload) before any layout mounted, so re-reading it was a
  // third /users/profile round trip on every login and every layout change.
  if (authStore.isLoggedIn()) {
    typedLocalize.setLanguage(authStore.user?.language);
  }
});
</script>

<template>
  <div class="details_background">
    <slot />
    <FeedbackContainer></FeedbackContainer>
  </div>
</template>

<style lang="scss">
.details_background {
  min-width: 100%;
  min-height: 100%;
  background: var(--white-main);
}
</style>
